exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ContextMenu-3dfcec6e{position:absolute;background:#212121;padding:7px 0;border-radius:4px;border:1px solid #e0e0e0;font-size:13px;line-height:15px;font-weight:500;color:#fff}.item-76e1cee9{cursor:pointer;padding:8px 15px;display:flex;justify-content:space-between}.item-76e1cee9:hover{background:#6982FF}.hint-a88d62ee{color:#bdbdbd;margin-left:20px}.scrim-7624d42c{position:absolute;top:0;left:0;right:0;bottom:0;z-index:5000}\n", ""]);

// Exports
exports.locals = {
	"ContextMenu": "ContextMenu-3dfcec6e",
	"item": "item-76e1cee9",
	"hint": "hint-a88d62ee",
	"scrim": "scrim-7624d42c"
};